import React from "react";
import "../Style/fullBanner.css";
import { Link } from "react-router-dom";
export default function FullBanner(props){
    const data = props.data;
    return <Link to={data.url} className="flex flexCol flexCenter container middleBannerLink">
        <img src={data.cover} alt={data.title} className="middleBannerImg" height="150" />
        <img src={data.mobileCover} alt={data.title} className="mobileMiddleBanner" height="150" />
    </Link>
}